const getWidgetID = () => {
  const widget = document.querySelector('div[data-personalization-id]')
  if (!widget) {
    return null
  }
  const widgetID = widget.dataset.personalizationId
  return widgetID
}

const reloadAPZUpsellWidget = () => {
  if (!window['pz-recommendations']) {
    return
  }
  const widgetID = getWidgetID()
  if (!widgetID) {
    return
  }
  window['pz-recommendations'].remove(widgetID)
  window['pz-recommendations'].initialRecommendation(widgetID)
}

document.addEventListener('on:cart-drawer:render_complete', () => {
  console.log('reload apz')
  reloadAPZUpsellWidget()
})
document.addEventListener('on:line-item:change', (event) => {
  console.log('reload apz')
  reloadAPZUpsellWidget()
})

const getRoutesRoot = () => {
  return window?.Shopify?.routes?.root ?? '/'
}

const getSections = async (cartDrawer) => {
  const sections = cartDrawer.getSectionsToRender().map(({ section }) => section)
  const url = getRoutesRoot() + "?sections=" + sections.join(",");
  const res = await window.fetch(url, {
    method: "GET",
  });
  const data = await res.json();
  return data;
}

const getCartData = async () => {
  const url = getRoutesRoot() + "cart.js"
  const res = await window.fetch(url, {
    method: "GET",
  });
  const data = await res.json();
  return data;
}

const refreshCart = async () => {
  const cartDrawer = document.querySelector('cart-drawer')
  if (!cartDrawer) {
    return
  }
  const isEmpty = cartDrawer.querySelector('.js-cart-empty')
  if (isEmpty) {
    const sections = await getSections(cartDrawer)
    const data = await getCartData();
    await cartDrawer.renderContents({ ...data, sections })
    reloadAPZUpsellWidget()
  } else {    
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'))
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true, // 是否冒泡
      detail: { 
        cb: () => {
          reloadAPZUpsellWidget()
        } 
      }
    }));
  }
}

document.addEventListener('apz:added', refreshCart)